import { defineComponent as _defineComponent } from 'vue'
import { MonetizationType, PresentationType } from '@/@types/graphql-types';
import { computed } from 'vue';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { faPlay, faTicket } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOfferCTA',
  props: {
    isBundle: { type: Boolean },
    offer: null,
    isLinearExpOffer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isBundle: boolean;
	offer: BuyboxRegularOffer;
	// EXP_LINEAR_TV
	isLinearExpOffer?: boolean;
	// EXP_LINEAR_TV
};



const { tc } = useI18n();

const highlightCta = computed(() => {
	return props.offer.monetizationType === MonetizationType.Flatrate && !props.isBundle;
});

const isDvdOrBluRay = computed(() =>
	[PresentationType.Dvd, PresentationType.Bluray, PresentationType.Bluray_4K].includes(props.offer?.presentationType)
);

const ctaText = computed(() => {
	if (isDvdOrBluRay.value) {
		return props.offer.monetizationType === MonetizationType.Rent ? tc('WEBAPP_RENT_NOW') : tc('WEBAPP_BUY_NOW');
	}

	// EXP_LINEAR_TV
	if (props.isLinearExpOffer) return tc('WEBAPP_WATCH_LIVE');
	// EXP_LINEAR_TV

	return props.offer.monetizationType === MonetizationType.Cinema
		? tc('WEBAPP_BOOKNOW_CINEMA')
		: tc('WEBAPP_WATCHNOW');
});

const ctaIcon = computed(() => {
	return props.offer.monetizationType === MonetizationType.Cinema ? faTicket : faPlay;
});

return { __sfc: true,props, tc, highlightCta, isDvdOrBluRay, ctaText, ctaIcon }
}

})